'use client';

import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Specification } from '@/types/product_page/productType';

const Specs = ({ data }: { data: Specification[] }) => {
  return (
    <section id="specifications" className="w-full py-6 md:py-10 px-4 md:px-6">
      <h1 className={`text-3xl font-bold text-center mb-6 md:mb-12`}>
        Specifications
      </h1>
      <div className={`max-w-desktop w-full mx-auto font-proxima_font`}>
        <Accordion
          defaultValue={
            data.length > 0
              ? [`${data[0]?.product_specifications_translations_id?.title}0`]
              : []
          }
          type="multiple"
          className="flex flex-col gap-4"
        >
          {data?.map((specs, index) => (
            <AccordionItem
              key={index}
              className={`border-none t`}
              value={`${specs?.product_specifications_translations_id?.title + index}`}
            >
              <AccordionTrigger className="text-base md:text-base font-semibold rounded-xl hover:no-underline px-6 py-4">
                {specs?.product_specifications_translations_id?.title}
              </AccordionTrigger>
              <AccordionContent>
                <div className="w-full px-5 grid grid-cols-1 md:grid-cols-2">
                  {specs?.product_specifications_translations_id?.specs?.map(
                    (spec, index) => (
                      <div
                        key={index}
                        className="flex flex-col md:flex-row w-full py-5 justify-start gap-3 border-b border-black/20"
                      >
                        <p className="font-bold text-sm lg:text-base md:w-[40%]">
                          {
                            spec?.product_specification_keyvalue_translations_id
                              ?.key?.key
                          }
                        </p>
                        <div className="md:w-[60%]">
                          {spec?.product_specification_keyvalue_translations_id?.value?.map(
                            (item, idx) => {
                              return (
                                <p
                                  key={idx}
                                  className="font-proxima_font text-off-black text-wrap text-left lg:text-base"
                                >
                                  {
                                    item
                                      ?.product_specification_value_translations_id
                                      ?.value
                                  }
                                </p>
                              );
                            }
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Specs;
